(function () {
  const analyticsTrackingId = 'G-3Q1T4RWXQF'

  const script = document.createElement('script')
  script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsTrackingId}&l=msaDataLayer`
  document.body.append(script)

  window.msaDataLayer = window.msaDataLayer || []
  gtag('js', new Date())
  gtag('config', analyticsTrackingId, {
    send_page_view: false
  })

  function gtag () {
    msaDataLayer.push(arguments)
  }

  const templateNote = document.querySelector('#multiple-size-avoidance-tmpl')
  const templateModal = document.querySelector('#size-guide-modal-tmpl')
  const context = JSON.parse(document.querySelector('#multi_size_avoidance_json').innerHTML)
  let updating = false
  let visible = false
  let variantMap = false

  let wasDisplayed = localStorage.getItem('femtis-multiple-size-avoidance-items')
  if (wasDisplayed) {
    wasDisplayed = JSON.parse(wasDisplayed)
  } else {
    wasDisplayed = {}
  }

  updateVariantMap()
  document.documentElement.addEventListener('wetheme-cart-update', updateVariantMap)

  takeOverLinkElements()
  setTimeout(takeOverLinkElements, 2500)
  setTimeout(takeOverLinkElements, 5000)
  setTimeout(takeOverLinkElements, 10000)
  setTimeout(takeOverLinkElements, 15000)

  function takeOverLinkElements () {
    document.querySelectorAll('#size-guide-link').forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault()
        if (element.classList.contains('f--msa-inited')) {
          return
        }

        element.classList.add('f--msa-inited')

        renderAdvisor()
      })
    })
  }

  function updateVariantMap () {
    updating = new Promise(resolve => {
      fetch(`${window.Shopify?.routes?.root}cart?view=items`)
        .then(response => response.json())
        .then(response => {
          variantMap = {}
          response.items.forEach(item => addToVariantMap(item.product_id, item.variant_id))
          updating = false
          resolve()
        })
    })
    updating.then(() => {})
  }

  function addToVariantMap (product_id, variant_id) {
    if (!variantMap[product_id]) {
      variantMap[product_id] = []
    }

    if (variantMap[product_id].indexOf(variant_id) === -1) {
      variantMap[product_id].push(variant_id)
    }
  }

  function suppress (product_id, variant_id) {
    const ttl = new Date()
    ttl.setDate(ttl.getDate() + 30)

    wasDisplayed[product_id] = ttl.getTime()
    localStorage.setItem('femtis-multiple-size-avoidance-items', JSON.stringify(wasDisplayed))

    addToVariantMap(product_id, variant_id)
  }

  document.documentElement.addEventListener('wetheme-add-to-cart', (event) => {
    if (updating) {
      updating.then(() => {
        resubmit(event.detail.form)
      })
      event.preventDefault()
      return
    }

    if (!variantMap) {
      return
    }

    const currentVariants = variantMap[event.detail.productId] ?? [];
    const currentIndex = currentVariants.indexOf(event.detail.variantId)
    if (currentIndex !== -1) {
      currentVariants.splice(currentIndex, 1)
    }

    if (!currentVariants.length) {
      return
    }

    if (!show(event.detail.productId, event.detail.variantId, event.detail.form)) {
      return
    }

    event.preventDefault()
  })

  function show (product_id, variant_id, form) {
    if (visible) {
      return false
    }
    visible = true

    if (wasDisplayed[product_id] && (new Date(wasDisplayed[product_id])) > (new Date).getTime()) {
      return false
    }

    return render(product_id, variant_id, form)
  }

  function render (product_id, variant_id, form) {
    const note = templateNote.cloneNode(true)
    note.removeAttribute('id')
    note.style.display = ''

    gtag('event', 'multiple_size_avoidance_visible')

    note.querySelector('.f-button.f--allow').addEventListener('click', () => {
      suppress(product_id, variant_id)
      resubmit(form)
      remove(note)
      gtag('event', 'multiple_size_avoidance_add_to_cart')
    })

    note.querySelector('.f-modal-content').addEventListener('click', () => {
      gtag('event', 'multiple_size_avoidance_canceled')
      remove(note)
    })
    note.querySelector('.f-msa-inner').addEventListener('click', e => e.stopPropagation())
    note.querySelector('.f-close').addEventListener('click', () => {
      gtag('event', 'multiple_size_avoidance_canceled')
      remove(note)
    })

    note.querySelector('.f-button.f--advisor').addEventListener('click', () => {
      suppress(product_id, variant_id)
      remove(note)
      gtag('event', 'multiple_size_avoidance_advisor')
      renderAdvisor()
    })

    document.body.style.overflow = 'hidden'
    document.body.appendChild(note)

    return true
  }

  function remove (element) {
    visible = false
    document.body.style.overflow = ''
    element.parentNode.removeChild(element)
  }

  function renderAdvisor () {
    const prefix = Shopify.locale === 'de' ? '' : `/${Shopify.locale}`;

    fetch(`${prefix}/pages/grossentabelle-modal`)
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser()
        const htmlDocument = parser.parseFromString(text, 'text/html')
        const content = htmlDocument.documentElement.querySelector('.page-main--wrapper')

        const modal = templateModal.cloneNode(true)
        modal.removeAttribute('id')
        modal.style.display = ''
        modal.querySelector('.f-close').addEventListener('click', () => remove(modal))
        modal.querySelector('.f-modal-content').addEventListener('click', () => remove(modal))
        modal.querySelector('.f-sgm-inner').addEventListener('click', e => e.stopPropagation())

        let html = content.innerHTML
          .replace('{product_title}', context.product.title)
          .replace('{fitting_key}', context.fitting.key)
          .replace('{fitting_label}', context.fitting.label.charAt(0).toLowerCase() + context.fitting.label.slice(1))

        if (window.matchMedia('(max-width: 500px)').matches) {
          html = html.replace('collapsible-tab js open', 'collapsible-tab js')
        }

        modal.querySelector('.f-sgm-content').innerHTML = html

        modal.querySelectorAll('.show-on-scroll')
          .forEach(el => el.classList.remove('show-on-scroll'))

        document.body.style.overflow = 'hidden'
        document.body.appendChild(modal)
      })
  }

  function resubmit (form) {
    form.dispatchEvent(new CustomEvent('submit', {
      cancelable: true,
      bubbles: false,
    }))
  }
})()
